import {RiaStatus} from '../../types'

export const getAvailableStatuses = (currentStatus: RiaStatus): RiaStatus[] => {
  // New is never a valid target, and Waived is no longer offered as a selectable
  // transition. The Waived enum value is kept only so historical RIAs already in
  // Waived still render correctly elsewhere (pills, audit log).
  const selectableStatuses = Object.values(RiaStatus).filter(
    (status) => status !== RiaStatus.New && status !== RiaStatus.Waived
  )

  return selectableStatuses.filter((status) => status !== currentStatus)
}
